// Browser polyfills for Node.js modules required by MSAL
import { Buffer } from 'buffer'

// Make polyfills available globally
declare global {
  interface Window {
    Buffer: typeof Buffer
    global: typeof globalThis
    process: any
  }
}

if (typeof window !== 'undefined') {
  // Buffer polyfill
  window.Buffer = Buffer
  
  // Global polyfill - essential for axios
  if (!window.global) {
    window.global = globalThis
  }
  
  // Ensure global is available at the top level too (for axios utils)
  if (typeof global === 'undefined') {
    ;(globalThis as any).global = globalThis
  }
  
  // Process polyfill - simple minimal implementation
  if (!window.process) {
    window.process = {
      env: {},
      nextTick: (callback: () => void) => setTimeout(callback, 0),
      browser: true,
      version: '',
      versions: {},
      platform: 'browser'
    }
  }

  // Crypto polyfill - use built-in crypto if available, otherwise provide fallback
  if (!window.crypto && typeof globalThis !== 'undefined') {
    // For MSAL, we need crypto.getRandomValues at minimum
    // Most modern browsers have crypto.getRandomValues, but let's provide a fallback
    const cryptoPolyfill = {
      getRandomValues: (array: any) => {
        for (let i = 0; i < array.length; i++) {
          array[i] = Math.floor(Math.random() * 256)
        }
        return array
      },
      // Add other crypto methods MSAL might need
      subtle: {
        digest: async () => { throw new Error('Crypto.subtle not available') },
        sign: async () => { throw new Error('Crypto.subtle not available') },
        verify: async () => { throw new Error('Crypto.subtle not available') }
      }
    }
    
    // Only set if crypto doesn't exist at all
    if (typeof globalThis.crypto === 'undefined') {
      globalThis.crypto = cryptoPolyfill as any
    }
  }
}

export {}